import React, {Component, useState} from 'react'
import logo from '../main3.png'
import HomeStyles from '../HomeStyles.css'
import RequestADemo from "../RequestADemo/requestademo";
import styled from "styled-components"; //Cautious: Don't remove this
import Bootstrap from 'react-bootstrap-icons';
import {BlockManager} from 'easy-email-core';
import {EmailEditor, EmailEditorProvider, IEmailTemplate} from 'easy-email-editor';
import {AdvancedType, BasicType, IBlockData, JsonToMjml} from 'easy-email-core';
import {ExtensionProps, StandardLayout, SimpleLayout, MjmlToJson} from 'easy-email-extensions';
import 'easy-email-editor/lib/style.css';
import 'easy-email-extensions/lib/style.css';
import '@arco-themes/react-easy-email-theme/css/arco.css';
import {Container, Row, Col, Carousel, Card} from 'react-bootstrap';
import EmailEditorStyle from "../EmailEditorStyle.css"
import EditorTopCard from "../Editor/EditorTopCard";
import CarouselItem from "../Editor/CarouselItem";
import './ExtendedEditorBheavior.css';
import {useMergeTagsModal} from '../../Components/useMergeTagsModal'
import {testMergeTags} from '../../Components/testMergeTags'
import HtmlFromMjML from "../Editor/HtmlFromMjML";
import EmailVerificationOnboard from "./EmailOnboarding/EmailVerificationOnboard";
import DataContext from '../Context/DataContext';
import {useContext} from 'react';
import {Card as MuiCard} from '@mui/material';
import CardContent from '@mui/material/CardContent';
import {useEffect} from 'react';
import HorizontalCarousel from './HorizontalCarousel'
import {ToastContainer, toast} from 'react-toastify';
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {getBaseUrlNodeServer} from "../../config";

//In future use the following for all the default loading templates
// const largeString = '<mjml>           <mj-head>     <mj-html-attributes>       <mj-html-attribute class="easy-email" multiple-attributes="false" attribute-name="text-color" text-color="#000000"></mj-html-attribute> <mj-html-attribute class="easy-email" multiple-attributes="false" attribute-name="font-family" font-family="-apple-system, BlinkMacSystemFont, \'Segoe UI\', \'Roboto\', \'Oxygen\', \'Ubuntu\', \'Cantarell\', \'Fira Sans\', \'Droid Sans\',\'Helvetica Neue\', sans-serif"></mj-html-attribute> <mj-html-attribute class="easy-email" multiple-attributes="false" attribute-name="font-size" font-size="14px"></mj-html-attribute> <mj-html-attribute class="easy-email" multiple-attributes="false" attribute-name="line-height" line-height="1.7"></mj-html-attribute> <mj-html-attribute class="easy-email" multiple-attributes="false" attribute-name="font-weight" font-weight="400"></mj-html-attribute> <mj-html-attribute class="easy-email" multiple-attributes="false" attribute-name="responsive" responsive="true"></mj-html-attribute>      </mj-html-attributes>                                                               <mj-breakpoint width="480px" />                                           <mj-attributes>                              <mj-all font-family="-apple-system, BlinkMacSystemFont, \'Segoe UI\', \'Roboto\', \'Oxygen\', \'Ubuntu\', \'Cantarell\', \'Fira Sans\', \'Droid Sans\',\'Helvetica Neue\', sans-serif" />               <mj-text font-size="14px" />               <mj-text color="#000000" />         <mj-text line-height="1.7" />         <mj-text font-weight="400" />                             </mj-attributes>           </mj-head>           <mj-body background-color="#efeeea" width="600px" ><mj-wrapper padding="20px 0px 20px 0px" border="none" direction="ltr" text-align="center" ><mj-section padding="0px" text-align="left" ><mj-column ><mj-text padding="10px 25px 10px 25px" align="left" >Make it easy for everyone to compose emails!</mj-text></mj-column></mj-section></mj-wrapper><mj-section padding="0px" text-align="left" ><mj-column ><mj-text padding="10px 25px 10px 25px" align="left" >Make it easy for everyone to compose emails!</mj-text></mj-column></mj-section></mj-body></mjml>'
// const instance = MjmlToJson(largeString)// as IBlockData;
export default function Demo() {
	const {contextData} = useContext(DataContext); //For function we need to use react hook to get the data
	const [parentDocId, setparentDocId] = useState('');
	var contactsAvailable = []
	if (contextData != null && contextData.length > 0) {
		contactsAvailable = contextData
	}
	const [inputText, setInputText] = useState('');
	const [outputText, setOutputText] = useState('');
	const [mjmlString, setMjmlString] = useState([]);
	const [subject, setSubject] = useState('');
	const [matchedDocId, setmatchedDocId] = useState('');
	const [initialValues, setInitialValues] = useState({
		subject: 'Welcome to Neugence Marketing',
		subTitle: '',
		content: BlockManager.getBlockByType(BasicType.PAGE).create({})
	});
	const {
		modal: mergeTagsModal, openModal: openMergeTagsModal, mergeTags, setMergeTags,
	} = useMergeTagsModal(testMergeTags);
	
	
	//Reference Don't Delete : https://github.com/zalify/easy-email/blob/59c40b41fbf8d93e87db9ca51d3a0856fa6f579e/demo/src/pages/Editor/index.tsx#L407
	
	const saveToBlogs = async () => {
		const mjmlStr = {mjmlString}.mjmlString
		const subject1 = {subject}.subject
		try {
			const response = await fetch(getBaseUrlNodeServer() + 'savetoblogs', {
				method: 'post',
				headers: {'Content-Type': 'application/json'},
				body: JSON.stringify({
					'mjmlStr': mjmlStr,
					'subject': subject1, 'templateId': {parentDocId}
				})
			})
		} catch (error) {
			console.error('Error during fetch:', error.message);
		}
	}
	
	//Load on the first one from the templates collection
	const loadTemplateWindowFromDataBase = async () => {
		try {
			const response = await fetch(getBaseUrlNodeServer() + 'getusertemplate', {
				method: 'post', headers: {'Content-Type': 'application/json'}
			})
			const mgmlTxt1 = await response.json();
			const mgmlTxt = mgmlTxt1[0]
			const pageData = MjmlToJson(mgmlTxt.content);
			const subject = mgmlTxt.subject;
			setInitialValues({
				subject: subject, subTitle: '', content: pageData
			})
		} catch (error) {
			console.error('Error during fetch:', error.message);
		}
	}
	
	const callOpenAPI = async () => {
		try {
			const response = await fetch('https://api.openai.com/v1/engines/davinci-codex/completions', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': 'Bearer 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', // Replace with your actual API key
				},
				body: JSON.stringify({
					prompt: 'Please dont explain in the response and keep the output short; ' + inputText,
					max_tokens: 150,
				}),
			});
			console.log('response', response);
			
			if (!response.ok) {
				throw new Error('API request failed');
			}
			
			const result = await response.json();
			setOutputText(result.choices[0].text.trim());
		} catch (error) {
			console.error('Error calling OpenAI API:', error);
		}
	};
	
	
	const saveUserTemplate = async () => {
		const mjmlStr = {mjmlString}.mjmlString
		const subject1 = {subject}.subject
		try {
			const response = await fetch(getBaseUrlNodeServer() + 'saveusertemplate', {
				method: 'post',
				headers: {'Content-Type': 'application/json'},
				body: JSON.stringify({
					'mjmlStr': mjmlStr,
					'subject': subject1, 'templateId': {parentDocId}
				})
			})
			// console.log(response)
		} catch (error) {
			console.error('Error during fetch:', error.message);
		}
	}
	const createUserTemplate = async () => {
		const mjmlStr = {mjmlString}.mjmlString
		const subject1 = {subject}.subject
		try {
			console.log(mjmlStr)
			console.log(subject1)
			
			const response = await fetch(getBaseUrlNodeServer() + 'createusertemplate', {
				method: 'post',
				headers: {'Content-Type': 'application/json'},
				body: JSON.stringify({'mjmlStr': mjmlStr, 'subject': subject1})
			})
			// console.log(response)
		} catch (error) {
			console.error('Error during fetch:', error.message);
		}
	}
	
	function setMjmlStrAndSubject(values) {//:IEmailTemplate
		//The following two blocks of code requires investigation otherwise our code could be shut down by these guys??
		const mjmlString = JsonToMjml({
			data: values.content, mode: 'production', context: values.content
		});
		setMjmlString(mjmlString)
		setSubject(values.subject)
	}
	
	const notifySuccess = (msg) => toast.success(msg, {
		position: "top-right",
		autoClose: 2000
	});
	const notifyFailure = (msg) => toast.success(msg, {
		position: "top-right",
		autoClose: 2000
	});
	
	const handleState = async (currDocId) => {
		notifySuccess('Selected your template in editor');
		try {
			const response = await fetch(getBaseUrlNodeServer() + 'getusertemplate/' + currDocId, {
				method: 'post', headers: {'Content-Type': 'application/json'}
			})
			const mgmlTxt1 = await response.json();
			const mgmlTxt = mgmlTxt1[0];
			const pageData = MjmlToJson(mgmlTxt.content);
			const subject = mgmlTxt.subject;
			// console.log('I am setting up ', {currDocId})
			setparentDocId(currDocId);
			setInitialValues({
				subject: subject, subTitle: '', content: pageData
			})
		} catch (error) {
			notifyFailure('Failed to select template')
			console.error('Error during fetch:', error.message);
		}
	};
	
	const data = [
		{title: 'New Campaign - Contacts Selected', value: contactsAvailable.length},
		{title: 'Emails Quota Left', value: 980},
		{title: 'Open Rate for Contacts', value: '12%'},
		// ...other data
	];
	// const width = useWindowSize();
	// const smallScene = width < 1200;
	return (
		<div style={{
			marginTop: "40px",
			marginLeft: "50px",
			display: "flex",
			flexBasis: "100%",
			flexDirection: "column",
			justifyContent: "center",
			justifyItems: "center",
			alignContent: "center",
			alignItems: "center"
		}}>
			<Grid container spacing={3}>
				{data.map((item, index) => (
					<Grid item xs={12} sm={6} md={4} key={index}>
						<MuiCard sx={{minWidth: 275, margin: 2}}>
							<CardContent>
								<Typography sx={{fontSize: 14}} color="grey" gutterBottom>
									{item.title}
								</Typography>
								<Typography variant="h5" component="h2">
									{item.value}
								</Typography>
							</CardContent>
						</MuiCard>
					</Grid>
				))}
			</Grid>
			<ToastContainer/>
			<h5 className="mb-3"
			    style={{textAlign: 'center', marginTop: '0px', color: '#968dff', fontWeight: 'bold'}}>
				Choose a template and start editing</h5>
			
			{/*TODO This guy sets the parentDocId, it reqruies that information to be shared with the parent*/}
			
			<div style={{boxShadow: "0 10px 10px rgba(0,0,0,0.1)", borderRadius: "20px", border: "0.1px solid lightgray"}}>
				<HorizontalCarousel handleState={handleState}/>
			</div>
			<h5 className="mb-3"
			    style={{textAlign: 'center', marginTop: '50px', color: '#968dff', fontWeight: 'bold'}}>
				Edit, Save and Send Campaign</h5>
			<div style={{width: "90vw", marginTop: "20px"}}>
				<EmailEditorProvider
					data={initialValues}
					// height={'calc(100vh - 72px)'}
					autoComplete
					dashed={true}
				>
					{({values}) => {
						return (<StandardLayout
							// compact={!smallScene}
							compact={!false}
							showSourceCode={true}
							onClick={setMjmlStrAndSubject(values)} //To Save the mjmlstring to the state variable for persisting to database
						>
							<EmailEditor/>
						</StandardLayout>);
					}}
				</EmailEditorProvider>
				
				<div style={{marginTop: '0px', textAlign: 'center'}}><p>Selected Template Id = {parentDocId}</p></div>
				
				<div style={{textAlign: 'center', marginTop: '20px'}}>
					<button id='publishtoblog' className={"btn"} onClick={saveToBlogs}
					        style={{backgroundColor: "lightgray", lineHeight: "1.5"}}
					>Publish To Blog
					</button>
				</div>
				<div style={{textAlign: 'center'}}>
					<button id='createnewdesign' className={"btn"} onClick={createUserTemplate}
					        style={{backgroundColor: "lightgray", lineHeight: "1.5"}}
					>Create New Page
					</button>
					<button id='savemydesign' className={"btn"} onClick={saveUserTemplate}
					        style={{backgroundColor: "lightgray", lineHeight: "1.5", marginLeft: '20px'}}
					>Save My Design
					</button>
				</div>
				<div style={{textAlign: 'center', marginTop: '20px'}}>
					<button id='loadfromdb' className={"btn"} onClick={loadTemplateWindowFromDataBase}
					        style={{backgroundColor: "lightgray", lineHeight: "1.5"}}
					>Load A Template From Database
					</button>
				
				</div>
				{/*TODO Add workspace features, create new workspace, save workspace*/}
			</div>
			<EmailVerificationOnboard parentDocId={parentDocId} emails={contactsAvailable}/>
		</div>)
}
